var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isGuest)?_c('v-alert',{attrs:{"type":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('rightsNotification'))+" ")]):_vm._e(),_c(_vm.profileComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }